import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=8dd23c0a&scoped=true&"
import script from "./pay.vue?vue&type=script&lang=js&"
export * from "./pay.vue?vue&type=script&lang=js&"
import style0 from "./pay.vue?vue&type=style&index=0&id=8dd23c0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd23c0a",
  null
  
)

export default component.exports